export const Common = {
    "系统提示":"系统提示",
    "提示":"提示",
    "暂无内容":"暫無內容",
    "暂无数据":"暫無數據～",
    "暂无动态":"暫無動態",
    "暂无疑问":"暫無疑問",
    "确定":"確定",
    "取消":"取消",
    "编辑":"編輯",
    "删除":"删除",
    "归档":"歸檔",
    "复制":"復制",
    "转让":"轉讓",
    "退课":"退課",
    "置顶":"置顶",
    "取消置顶":"取消置頂",
    "启用加课码":"啟用加課碼",
    "重置加课码":"重置加課碼",
    "停用加课码":"停用加課碼",
    "排序":"排序",
    "完成":"完成",
    "添加活动":"添加活動",
    "重命名":"重命名",
    "恢复":"恢復",
    "加载中":"加載中...",
    "图片加载中":"圖片加載中...",
    "加载失败":"加載失敗",
    "添加":"添加",
    "保存":"保存",
    "删除提示":"刪除提示",
    "删除成功":"删除成功!",
    "暂无":"暫無",
    "没有更多了":"没有更多了",
    "添加到章节":"添加到章節",
    '线上':'線上',
    '线下':'線下',
    '混合':'混合',
    "学":"學",
    "教":"教",
    "协":"協",
    "请输入名称":"請輸入名稱",
    "提交":"提交",
    "搜索":"搜索",
    "变更成功":"變更成功",
    "讨论":"討論",
    "按时间顺序":"按時間順序",
    "老师":"老師",
    "发布于":"發布於",
    "回复":"回復",
    "暂无评论":"暫無評論",
    "发送":"發送",
    "请输入":"請輸入...",
    "发表评论":"發表評論...",
    CourseMenu:{
        "目录":"目錄",
        "互动课件":"互動課件",
        "作业":"作業",
        "测试":"測試",
        "资料":"資料",
        "腾讯会议":"騰訊會議",
        "公告":"公告",
        "话题":"話題",
        "互动答题":"互動答題",
        "互动":"互動",
        "答题":"答題",
        "课件":"課件",
        "会议":"會議",
        "案例学习":"案例學習",
  },
  "选择章节":"選擇章節",
  "定时器已存在":"定時器已存在！",
  "全部":"全部",
  "发布":"發布",
  "结束发布":"結束發布",
  "展开全部":"展開全部",
  "条回复":"條回復",
  "全部回复":"全部回復",
  "第":"第",
  "页":"頁",
  "个人详情页":"個人詳情頁",
  "疑问":"疑問",
  "请输入学生姓名学号":"請輸入學生姓名學號",
  "完成时间":"完成时间：",
  "分":"分",
  "完善成功":"完善成功",
  "选课":"選課",
  "人":"人",
  "加课":"加課",
  "到期":"",
  "截止":"截止",
  "开始时间":"開始時間：",
  "创建于":"創建於",
  "下一步":"下壹步",
  "上一步":"上壹步",
  "错误":"錯誤",
  "来自":"来自：",
  "赞":"贊",
  "分享":"分享",
  "编辑会议直播":"編輯會議直播",
  "编辑话题讨论":"編輯話題討論",
  "编辑文章内容":"編輯文章內容",
  "编辑视频内容":"編輯視頻內容",
  "仅老师可以申请加入教研室":"僅老師可以申請加入教研室",
  "请求失败点击重新加载":"請求失敗，點擊重新加載",
  "点击进行下载":"點擊進行下載",
  "播放观看":"播放觀看",
  "总页":"頁",
  "阅读全文":"閱讀全文",
  "点击查看":"點擊查看",
  "申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质教学资源":"申請加入虛擬教研室可以繼續閱讀，和名師壹起研討，引用優質教學資源",
  "当前文件格式不支持预览请下载到本地查看":"當前文件格式不支持預覽，請下載到本地查看",
  "申明内容来自用户上传著作权归原作者所有如涉侵权问题请联系平台官方客服我们将及时处理":"申明：內容來自用戶上傳，著作權歸原作者所有，如涉侵權問題，請聯系平臺官方客服，我們將及時處理",
  "申请加入":"申請加入",
  "参与评论":"參與評論！",
  "阅读":"閱讀",
  "动态":"動態",
  "资源":"資源",
  "已加入":"已加入",
  "文科类":"文科類",
  "您已经加入不需要重复加入":"您已經加入，不需要重復加入",
  "加入虚拟教研室立即使用":"加入虛擬教研室，立即使用",
  "根据管理者的权限设置您没有权限下载该资源":"根據管理者的權限設置，您沒有權限下載該資源",
  "请选择一个课程":"請選擇壹個課程",
  "该链接无法跳转":"該鏈接無法跳轉",
  "点赞":"點贊",
  "评论":"評論",
  "已取消点赞":"已取消點贊",
  "点赞成功":"點贊成功",
  "查看链接":"查看鏈接",
  "直播回放 ":"直播回放",
  "浏览":"瀏覽",
  "创建人":"創建人：",
  "授课对象":"授課對象：",
  "试卷":"試卷",
  "来自样板课程":"來自樣板課程：",
  "道试题":"道試題",
  "收起":"收起",
  "文章":"文章",
  "人次参与讨论":"人次參與討論",
  "分享卡":"分享卡",
  "长按保存图片或发送给朋友":"長按保存圖片或發送給朋友。",
  "链接复制失败":"鏈接復制失敗",
  "链接复制成功":"鏈接復制成功",
  "已经全部加载完了没有更多了":"已經全部加載完了，沒有更多了",
  "继续阅读":"繼續閱讀",
  "剩余":"剩余",
  "条动态未读":"條動態未讀",
  "导入":"導入",
  "课件":"課件",
  "发布成功":"發布成功",
  "导入成功":"導入成功",
  "添加成功":"添加成功",
  "保存成功":"保存成功",
  "外链":"外鏈",
  "本地上传":"本地上傳",
  "导入已有":"導入已有",
  "文件上传失败":"文件上傳失敗",
  "课前":"課前",
  "全部成员":"全部成員",
  "慕课视频":"慕課視頻",
  "录播":"錄播",
  "未发布":"未發布",
  "未开始":"未開始",
  "进行中":"進行中",
  "已结束":"已結束",
  "详情":"詳情",
  "已选":"已選",
  "个课程":"個課程",
  "立即加入学习":"立即加入學習",
  "选修课程":"選修課程",
  "可批量选择课程并加入":"可批量選擇課程並加入",
  "人已学习":"人已學習",
  "请至少选择一个课程":"請至少選擇壹個課程",
  "请先登录":"請先登錄",
  "立即登录":"立即登錄",
  "请先进行身份认证":"請先進行身份認證",
  "立即认证":"立即認證",
  "重命名文件":"重命名文件",
  "请输入文件名":"請輸入文件名",
  "修改成功":"修改成功",
  "关闭":"關閉",
  "刷新成功":"刷新成功!",
  "反馈类型":"反饋類型",
  "您的邮箱":"您的郵箱",
  "请输入邮箱地址":"請輸入郵箱地址",
  "问题描述":"問題描述",
  "这里输入您反馈的问题":"這裏輸入您反饋的問題…",
  "使用帮助":"使用幫助",
  "产品建议":"產品建議",
  "功能异常":"功能異常",
  "请确认邮箱":"請確認郵箱",
  "请输入反馈问题":"請輸入反饋問題",
  "常见问题":"常見問題",
  "搜索您的问题或关键词":"搜索您的問題或關鍵詞",
  "意见反馈":"意見反饋",
  "个搜索结果":"個搜索結果",
  "无符合条件的搜索结果":"無符合條件的搜索結果",
  "章节目录":"章節目錄",
  "暂无简介":"暫無簡介",
  "课程内容":"課程內容",
  "加入老师的课程后可查看详情并学习":"加入老師的課程後可查看詳情並學習",
  "该课程已关闭":"該課程已關閉",
  "关注课堂派公众号发现更多精彩课程":"關註課堂派公眾號，發現更多精彩課程",
  "立即加入":"立即加入",
  "立即学习":"立即學習",
  "华文慕课视频":"華文慕課視頻",
  "华文慕课外链":"華文慕課外鏈",
  "进入直播":"進入直播",
  "直播未开启":"直播未開啟",
  "发送弹幕评论":"發送彈幕/評論...",
  "直播技术由课堂派提供发送弹幕需要先登录课堂派是否立即登录":"直播技術由課堂派提供，發送彈幕需要先登錄課堂派，是否立即登錄？",
  "前往登录":"前往登錄",
  "继续观看":"繼續觀看",
  "直播暂停或已结束":"直播暫停或已結束",
  "至少选择一个":"至少選擇壹個",
  "全屏预览":"全屏預覽",
}